import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
const defaultTrailing = '…';
const defaultLength = 40;
let TruncateCharactersPipe = /*#__PURE__*/(() => {
  class TruncateCharactersPipe {
    transform(value, ...options) {
      const limit = options[0] || defaultLength;
      let trailingString = '';
      let countTrailing = false;
      const safeValue = value || '';
      if (options && options[1] && typeof options[1] === 'object') {
        trailingString = options[1].trailingString || defaultTrailing;
        countTrailing = options[1].countTrailing || false;
      } else {
        trailingString = options[1] || defaultTrailing;
        countTrailing = options[2] || false;
      }
      let stringLength = this.getStringLength(limit, trailingString, countTrailing);
      if (stringLength < 0) {
        stringLength *= -1;
        return safeValue.length > stringLength ? trailingString + safeValue.substring(safeValue.length - stringLength, safeValue.length) : safeValue;
      }
      return safeValue.length > stringLength ? safeValue.substring(0, stringLength) + trailingString : safeValue;
    }
    getStringLength(limit, trail, countTrailing = false) {
      if (countTrailing) {
        if (limit < 0) {
          return limit + trail.length;
        }
        return limit - trail.length;
      }
      return limit;
    }
  }
  TruncateCharactersPipe.ɵfac = function TruncateCharactersPipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TruncateCharactersPipe)();
  };
  TruncateCharactersPipe.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "truncate",
    type: TruncateCharactersPipe,
    pure: true,
    standalone: false
  });
  return TruncateCharactersPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TruncateWordsPipe = /*#__PURE__*/(() => {
  class TruncateWordsPipe {
    transform(value, limit = 40, trail = '…') {
      let result = value || '';
      if (value) {
        const words = value.split(/\s+/);
        if (words.length > Math.abs(limit)) {
          if (limit < 0) {
            // eslint-disable-next-line no-param-reassign
            limit *= -1;
            result = trail + words.slice(words.length - limit, words.length).join(' ');
          } else {
            result = words.slice(0, limit).join(' ') + trail;
          }
        }
      }
      return result;
    }
  }
  TruncateWordsPipe.ɵfac = function TruncateWordsPipe_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TruncateWordsPipe)();
  };
  TruncateWordsPipe.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
    name: "words",
    type: TruncateWordsPipe,
    pure: true,
    standalone: false
  });
  return TruncateWordsPipe;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const TRUNCATE_PIPES = [TruncateCharactersPipe, TruncateWordsPipe];
let TruncateModule = /*#__PURE__*/(() => {
  class TruncateModule {}
  TruncateModule.ɵfac = function TruncateModule_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || TruncateModule)();
  };
  TruncateModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: TruncateModule
  });
  TruncateModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  return TruncateModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/*
 * Public API Surface of ng-truncate
 */

/**
 * Generated bundle index. Do not edit.
 */

export { TruncateCharactersPipe, TruncateModule, TruncateWordsPipe };
